// extracted by mini-css-extract-plugin
module.exports = {"text":"titleSection-module--text--2QRWD","logo":"titleSection-module--logo--1LLzv","image":"titleSection-module--image--1R8JL"};